import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { useQuery } from "@apollo/client";
import toast from "react-hot-toast";
import { MdDownload, MdOutlineRemoveRedEye, MdArrowBack } from "react-icons/md";
import claims from "../../gql/claims";
import { Box, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import AppTable from "../../shared/AppTable";
import AppButton from "../../shared/AppButton";
import ModernJsonReader from "../../shared/ModernJsonReader";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ClaimJsonViewModal({
  open,
  setOpen,
  handleClose,
  selectedItem,
}) {
  const [item, setItem] = useState(null);
  const [showJsonView, setShowJsonView] = useState(false);
  const [jsonObject, setJsonObject] = useState(null);
  const [logsData, setLogsData] = useState([]);
  const { t } = useTranslation();

  const [jsonDialogOpen, setJsonDialogOpen] = useState(false);

  const handleJsonDialogOpen = () => setJsonDialogOpen(true);
  const handleJsonDialogClose = () => setJsonDialogOpen(false);

  const showJson = (item) => {
    setJsonObject(item);
    setShowJsonView(true);
    setJsonDialogOpen(true);
  };

  const onCloseShowJson = () => setShowJsonView(false);

  const { loading, error, data, refetch } = useQuery(
    claims.GET_CLAIMS_TRAN_DETAILS_LOGS,
    {
      variables: {
        transactionId: selectedItem?.transaction_id,
      },
      skip: !selectedItem?.transaction_id,
    },
  );

  useEffect(() => {
    if (data) {
      setLogsData(data?.getClaimTransaction?.data?.logs || []);
    }
  }, [data]);

  const formatDate = (backendDateTime) => {
    const date = new Date(backendDateTime);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear());
    return `${day}-${month}-${year}`;
  };

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });
    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToJson = (item) => {
    downloadFile({
      data: JSON.stringify(JSON.parse(item.log)),
      fileName: `${item.type}.json`,
      fileType: "text/json",
    });
  };

  const handleViewJson = (row) => {
    setJsonObject(JSON.parse(row.log));
    setJsonDialogOpen(true);
  };

  const handleDownload = (row) => {
    downloadFile({
      data: JSON.stringify(JSON.parse(row.log)),
      fileName: `${row.type}.json`,
      fileType: "text/json",
    });
  };

  const columns = [
    {
      header: t("SQ #"),
      render: (row, index) => index + 1,
      align: "center",
    },
    {
      header: t("Transaction ID"),
      field: "transaction_id",
    },
    {
      header: t("Transaction Types"),
      field: "type",
    },
    {
      header: t("Date"),
      render: (row) => {
        const date = new Date(row.timestamp);
        return `${String(date.getDate()).padStart(2, "0")}-${String(
          date.getMonth() + 1,
        ).padStart(2, "0")}-${date.getFullYear()}`;
      },
    },
  ];

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={() => {
          jsonDialogOpen ? setJsonDialogOpen(false) : handleClose();
        }}
        TransitionComponent={Transition}
        style={{ background: "#0070C2", zIndex: 100 }}
      >
        <AppBar sx={{ position: "relative", backgroundColor: "#0070C2" }}>
          <Toolbar style={{ background: "#0070C2" }}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                jsonDialogOpen ? setJsonDialogOpen(false) : handleClose();
              }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {t("Claims JSON View")}
            </Typography>
            <Button
              autoFocus
              color="inherit"
              size="small"
              onClick={() => {
                jsonDialogOpen ? setJsonDialogOpen(false) : handleClose();
              }}
            >
              {t("Close")}
            </Button>
          </Toolbar>
        </AppBar>

        <Box sx={{ p: 3 }}>
          {jsonDialogOpen ? (
            <div className="animate-fade-in">
              <div className="mb-2">
                <AppButton
                  variant="outlined"
                  label={t("Back to List")}
                  onClick={() => setJsonDialogOpen(false)}
                  className="!text-primary !border-primary hover:bg-primary/50"
                  startIcon={<MdArrowBack />}
                />
              </div>
              <ModernJsonReader data={jsonObject} />
            </div>
          ) : (
            <AppTable
              columns={columns}
              data={logsData}
              loading={loading}
              onView={handleViewJson}
              onDownload={handleDownload}
            />
          )}
        </Box>
      </Dialog>
    </div>
  );
}
